import { Product } from "../types/response"

export function isProduct(product: any): product is Product {
    return Object.prototype.hasOwnProperty.call(product, "name")
}
